var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.65404 3.12927C1.02563 3.94687 0.551785 4.88921 0.275879 5.91293H4.43769L1.65404 3.12927Z",
    fill: "#0052B4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7242 5.91314C15.4483 4.88945 14.9745 3.94711 14.3461 3.12952L11.5625 5.91314H15.7242Z",
    fill: "#0052B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.275879 10.0869C0.551816 11.1106 1.02566 12.0529 1.65404 12.8705L4.4376 10.0869H0.275879Z",
    fill: "#0052B4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8708 1.6537C12.0532 1.02529 11.1109 0.55145 10.0872 0.275513V4.43729L12.8708 1.6537Z",
    fill: "#0052B4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.12939 14.3462C3.94699 14.9746 4.88933 15.4484 5.91302 15.7244V11.5626L3.12939 14.3462Z",
    fill: "#0052B4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91299 0.275513C4.8893 0.55145 3.94696 1.02529 3.12939 1.65367L5.91299 4.43726V0.275513Z",
    fill: "#0052B4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0872 15.7244C11.1108 15.4484 12.0532 14.9746 12.8708 14.3462L10.0872 11.5626V15.7244Z",
    fill: "#0052B4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5625 10.0869L14.3461 12.8705C14.9745 12.053 15.4483 11.1106 15.7242 10.0869H11.5625Z",
    fill: "#0052B4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9323 6.95653H9.04353H9.0435V0.0677188C8.70191 0.02325 8.35366 0 8 0C7.64628 0 7.29809 0.02325 6.95653 0.0677188V6.95647V6.9565H0.0677188C0.02325 7.29809 0 7.64634 0 8C0 8.35372 0.02325 8.70191 0.0677188 9.04347H6.95647H6.9565V15.9323C7.29809 15.9768 7.64628 16 8 16C8.35366 16 8.70191 15.9768 9.04347 15.9323V9.04353V9.0435H15.9323C15.9768 8.70191 16 8.35372 16 8C16 7.64634 15.9768 7.29809 15.9323 6.95653Z",
    fill: "#D80027"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0872 10.0869L13.657 13.6568C13.8212 13.4927 13.9778 13.3211 14.1273 13.1432L11.071 10.0869H10.0872V10.0869Z",
    fill: "#D80027"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91317 10.087H5.91311L2.34326 13.6569C2.50739 13.8211 2.67898 13.9777 2.85686 14.1271L5.91317 11.0708V10.087Z",
    fill: "#D80027"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91268 5.91311V5.91305L2.34281 2.34314C2.17862 2.50726 2.022 2.67886 1.87256 2.85673L4.9289 5.91308H5.91268V5.91311Z",
    fill: "#D80027"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0872 5.91308L13.6571 2.34314C13.4929 2.17896 13.3213 2.02233 13.1435 1.87292L10.0872 4.92927V5.91308Z",
    fill: "#D80027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUk);
export default __webpack_public_path__ + "static/media/uk.18af8985dd182817fdb78034b1fb6548.svg";
export { ForwardRef as ReactComponent };